class OrderStatus {
	constructor(containerElement) {
		this.orderId = this.getOrderId();
		this.containerElement = containerElement;
		this.actionContainers = this.containerElement.querySelectorAll('.action-container');

		if (!this.actionContainers.length) {
			return;
		}

		this.newPaymentActionContainer = this.containerElement.querySelector('.new-payment-action');
		this.newPaymentActionTrigger = this.newPaymentActionContainer.querySelector('button');
		this.checkStatusActionContainer = this.containerElement.querySelector('.check-status-action');
		this.checkStatusActionTrigger = this.checkStatusActionContainer.querySelector('button');
		this.finishedActionContainer = this.containerElement.querySelector('.finished-action');

		this.addEventListeners()
	}

	render() {

	}

	getOrderId() {
		let searchParams = new URLSearchParams(window.location.search);
		return searchParams.has('order') ? searchParams.get('order') : null;
	}

	newPaymentAction() {

		if (this.newPaymentActionTrigger.classList.contains('running')) {
			return;
		}

		this.newPaymentActionTrigger.classList.add('running')

		let xhr = new XMLHttpRequest();
		xhr.open("POST", this.newPaymentActionContainer.getAttribute('action'), true);
		xhr.setRequestHeader('Content-Type', 'application/json');
		xhr.send(JSON.stringify({
			clickAndCollect: {
				orderId: this.orderId
			}
		}));
		xhr.onreadystatechange = () => {
			if(xhr.readyState === 4 && xhr.status === 200) {
				// alert(xhr.responseText);
				this.handleResponse(xhr.responseText)
			}

			this.newPaymentActionTrigger.classList.remove('running')
		}
	}

	checkStatusAction() {


		if (this.checkStatusActionTrigger.classList.contains('running')) {
			return;
		}

		this.checkStatusActionTrigger.classList.add('running')

		let xhr = new XMLHttpRequest();
		xhr.open("POST", this.checkStatusActionContainer.getAttribute('action'), true);
		xhr.setRequestHeader('Content-Type', 'application/json');
		xhr.send(JSON.stringify({
			clickAndCollect: {
				orderId: this.orderId
			}
		}));
		xhr.onreadystatechange = () => {
			if(xhr.readyState === 4 && xhr.status === 200) {
				// alert(xhr.responseText);
				this.handleResponse(xhr.responseText)
			}

			this.checkStatusActionTrigger.classList.remove('running')
		}
	}

	handleResponse(responseText) {

		// console.log(responseText);

		let response;

		try {
			response = JSON.parse(responseText);
		} catch (e) {
			//@todo handle big fail, probably network
			console.log(e, responseText);
			alert(responseText);
			return;
		}

		if (!response || !response.payload) {
			//@todo handle big fail, probably network
			console.log(e, responseText);
			alert(responseText);
			return;
		}

		if (!response.payload.orderId) {
			//@todo handle order not found
			alert(responseText);
			return;
		}

		if (response.payload.redirect) {
			window.location.href = response.payload.redirect;
			return;
		}

		if (!response.payload.paymentStatus || response.payload.paymentStatus === 'failed') {
			this.showActionContainer(this.newPaymentActionContainer);
			return;
		}

		if (response.payload.paymentStatus && response.payload.paymentStatus === 'finished') {
			this.showActionContainer(this.finishedActionContainer);
			return;
		}

		if (response.payload.paymentStatus && (
			response.payload.paymentStatus === 'opened' || response.payload.paymentStatus === 'authorized'
		)) {
			this.showActionContainer(this.checkStatusActionContainer);
			return;
		}

	}

	showActionContainer(actionContainer) {
		this.actionContainers.forEach(container => {
			container.classList.remove('visible');
		});
		actionContainer.classList.add('visible');
	}

	addEventListeners() {
		this.checkStatusActionTrigger.addEventListener('click', event => {
			this.checkStatusAction();
		})

		this.newPaymentActionTrigger.addEventListener('click', event => {
			this.newPaymentAction();
		})
	}

}

let orderStatusContainer = document.querySelector('.dotpulse-eldora-restaurant-orderstatus');
if (orderStatusContainer) {
	new OrderStatus(orderStatusContainer);
}
